// WhatsApp Template Category Options
export const WHATSAPP_TEMPLATE_CATEGORIES = [
	{id: 'AUTHENTICATION', name: 'Authentication'},
	{id: 'MARKETING', name: 'Marketing'},
	{id: 'UTILITY', name: 'Utility'}
];

// WhatsApp Parameter Format Options
export const WHATSAPP_PARAMETER_FORMATS = [
	{id: 'named', name: 'Named ({{param_name}})'},
	{id: 'positional', name: 'Positional ({{1}}, {{2}}, ...)'}
];

// WhatsApp Language Codes
// Source: WhatsApp Business Platform supported languages
export const WHATSAPP_LANGUAGE_CODES = [
	{id: 'af', name: 'Afrikaans (af)'},
	{id: 'sq', name: 'Albanian (sq)'},
	{id: 'ar', name: 'Arabic (ar)'},
	{id: 'ar_EG', name: 'Arabic (EGY) (ar_EG)'},
	{id: 'ar_UAE', name: 'Arabic (UAE) (ar_UAE)'},
	{id: 'ar_LB', name: 'Arabic (LBN) (ar_LB)'},
	{id: 'ar_MA', name: 'Arabic (MAR) (ar_MA)'},
	{id: 'ar_QA', name: 'Arabic (QAT) (ar_QA)'},
	{id: 'az', name: 'Azerbaijani (az)'},
	{id: 'be_BY', name: 'Belarusian (be_BY)'},
	{id: 'bn', name: 'Bengali (bn)'},
	{id: 'bn_IN', name: 'Bengali (IND) (bn_IN)'},
	{id: 'bg', name: 'Bulgarian (bg)'},
	{id: 'ca', name: 'Catalan (ca)'},
	{id: 'zh_CN', name: 'Chinese (CHN) (zh_CN)'},
	{id: 'zh_HK', name: 'Chinese (HKG) (zh_HK)'},
	{id: 'zh_TW', name: 'Chinese (TAI) (zh_TW)'},
	{id: 'hr', name: 'Croatian (hr)'},
	{id: 'cs', name: 'Czech (cs)'},
	{id: 'da', name: 'Danish (da)'},
	{id: 'prs_AF', name: 'Dari (prs_AF)'},
	{id: 'nl', name: 'Dutch (nl)'},
	{id: 'nl_BE', name: 'Dutch (BEL) (nl_BE)'},
	{id: 'en', name: 'English (en)'},
	{id: 'en_GB', name: 'English (UK) (en_GB)'},
	{id: 'en_US', name: 'English (US) (en_US)'},
	{id: 'en_AE', name: 'English (UAE) (en_AE)'},
	{id: 'en_AU', name: 'English (AUS) (en_AU)'},
	{id: 'en_CA', name: 'English (CAN) (en_CA)'},
	{id: 'en_GH', name: 'English (GHA) (en_GH)'},
	{id: 'en_IE', name: 'English (IRL) (en_IE)'},
	{id: 'en_IN', name: 'English (IND) (en_IN)'},
	{id: 'en_JM', name: 'English (JAM) (en_JM)'},
	{id: 'en_MY', name: 'English (MYS) (en_MY)'},
	{id: 'en_NZ', name: 'English (NZL) (en_NZ)'},
	{id: 'en_QA', name: 'English (QAT) (en_QA)'},
	{id: 'en_SG', name: 'English (SGP) (en_SG)'},
	{id: 'en_UG', name: 'English (UGA) (en_UG)'},
	{id: 'en_ZA', name: 'English (ZAF) (en_ZA)'},
	{id: 'et', name: 'Estonian (et)'},
	{id: 'fil', name: 'Filipino (fil)'},
	{id: 'fi', name: 'Finnish (fi)'},
	{id: 'fr', name: 'French (fr)'},
	{id: 'fr_BE', name: 'French (BEL) (fr_BE)'},
	{id: 'fr_CA', name: 'French (CAN) (fr_CA)'},
	{id: 'fr_CH', name: 'French (CHE) (fr_CH)'},
	{id: 'fr_CI', name: 'French (CIV) (fr_CI)'},
	{id: 'fr_MA', name: 'French (MAR) (fr_MA)'},
	{id: 'ka', name: 'Georgian (ka)'},
	{id: 'de', name: 'German (de)'},
	{id: 'de_AT', name: 'German (AUT) (de_AT)'},
	{id: 'de_CH', name: 'German (CHE) (de_CH)'},
	{id: 'el', name: 'Greek (el)'},
	{id: 'gu', name: 'Gujarati (gu)'},
	{id: 'ha', name: 'Hausa (ha)'},
	{id: 'he', name: 'Hebrew (he)'},
	{id: 'hi', name: 'Hindi (hi)'},
	{id: 'hu', name: 'Hungarian (hu)'},
	{id: 'id', name: 'Indonesian (id)'},
	{id: 'ga', name: 'Irish (ga)'},
	{id: 'it', name: 'Italian (it)'},
	{id: 'ja', name: 'Japanese (ja)'},
	{id: 'kn', name: 'Kannada (kn)'},
	{id: 'kk', name: 'Kazakh (kk)'},
	{id: 'rw_RW', name: 'Kinyarwanda (rw_RW)'},
	{id: 'ko', name: 'Korean (ko)'},
	{id: 'ky_KG', name: 'Kyrgyz (Kyrgyzstan) (ky_KG)'},
	{id: 'lo', name: 'Lao (lo)'},
	{id: 'lv', name: 'Latvian (lv)'},
	{id: 'lt', name: 'Lithuanian (lt)'},
	{id: 'mk', name: 'Macedonian (mk)'},
	{id: 'ms', name: 'Malay (ms)'},
	{id: 'ml', name: 'Malayalam (ml)'},
	{id: 'mr', name: 'Marathi (mr)'},
	{id: 'nb', name: 'Norwegian (nb)'},
	{id: 'ps_AF', name: 'Pashto (ps_AF)'},
	{id: 'fa', name: 'Persian (fa)'},
	{id: 'pl', name: 'Polish (pl)'},
	{id: 'pt_BR', name: 'Portuguese (BR) (pt_BR)'},
	{id: 'pt_PT', name: 'Portuguese (POR) (pt_PT)'},
	{id: 'pa', name: 'Punjabi (pa)'},
	{id: 'ro', name: 'Romanian (ro)'},
	{id: 'ru', name: 'Russian (ru)'},
	{id: 'sr', name: 'Serbian (sr)'},
	{id: 'si_LK', name: 'Sinhala (si_LK)'},
	{id: 'sk', name: 'Slovak (sk)'},
	{id: 'sl', name: 'Slovenian (sl)'},
	{id: 'es', name: 'Spanish (es)'},
	{id: 'es_AR', name: 'Spanish (ARG) (es_AR)'},
	{id: 'es_CL', name: 'Spanish (CHL) (es_CL)'},
	{id: 'es_CO', name: 'Spanish (COL) (es_CO)'},
	{id: 'es_CR', name: 'Spanish (CRI) (es_CR)'},
	{id: 'es_DO', name: 'Spanish (DOM) (es_DO)'},
	{id: 'es_EC', name: 'Spanish (ECU) (es_EC)'},
	{id: 'es_HN', name: 'Spanish (HND) (es_HN)'},
	{id: 'es_MX', name: 'Spanish (MEX) (es_MX)'},
	{id: 'es_PA', name: 'Spanish (PAN) (es_PA)'},
	{id: 'es_PE', name: 'Spanish (PER) (es_PE)'},
	{id: 'es_ES', name: 'Spanish (SPA) (es_ES)'},
	{id: 'es_UY', name: 'Spanish (URY) (es_UY)'},
	{id: 'sw', name: 'Swahili (sw)'},
	{id: 'sv', name: 'Swedish (sv)'},
	{id: 'ta', name: 'Tamil (ta)'},
	{id: 'te', name: 'Telugu (te)'},
	{id: 'th', name: 'Thai (th)'},
	{id: 'tr', name: 'Turkish (tr)'},
	{id: 'uk', name: 'Ukrainian (uk)'},
	{id: 'ur', name: 'Urdu (ur)'},
	{id: 'uz', name: 'Uzbek (uz)'},
	{id: 'vi', name: 'Vietnamese (vi)'},
	{id: 'zu', name: 'Zulu (zu)'}
];





